"use client";

import {
  ColumnDef,
  ExpandedState,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { t } from "i18next";

import React, { useEffect } from "react";
import { ScrollArea } from "../ScrollArea/ScrollArea";
import { Separator } from "../Separator";
import { TableCell, TableRow } from "../Table/Table";
import { NavLink } from "react-router-dom";

interface DataTableProps<TData, TValue> {
  route: string;
  columns: ColumnDef<TData, TValue>[];
  data: TData[];
  onClickRow?: Function;
}

export function MenuDataTable<TData, TValue>({
  route,
  columns,
  data,
  onClickRow,
}: DataTableProps<TData, TValue>) {
  const [expanded, setExpanded] = React.useState<ExpandedState>({});

  const table = useReactTable({
    data,
    columns,
    state: {
      expanded,
    },
    onExpandedChange: setExpanded,
    //@ts-ignore
    getSubRows: (row) => row.subRows, // Выбор свойства объекта, где находятся дочерние элементы дерева
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
  });

  useEffect(() => {
    table.toggleAllRowsExpanded();
  }, []);

  return (
    <>
      {table.getHeaderGroups().map((headerGroup) => (
        <div key={headerGroup.id} className="flex px-6 pt-3">
          {headerGroup.headers.map((header) => {
            return (
              <div key={header.id} className={`${header.getSize() === 1000 ? "grow flex" : "flex flex-none w-[" + header.getSize() + "px]"} h-6 text-sm font-medium`}>
                <div className={`${"min-w-[" + header.getSize() + "px]"}`}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</div>
              </div>
            );
          })}
        </div>
      ))}
      <div className="px-6">
        <Separator/>
      </div>
      
      <ScrollArea className="w-full">
        {table.getRowModel().rows?.length ? (
          table.getRowModel().rows.map((row) => (
            //@ts-ignore
            <NavLink key={row.original.id} to={`${route}/${row.original.id}`} onClick={() => onClickRow?.(row.original.id)} >
              {({ isActive }) => (
                <div
                  className={`cursor-pointer flex w-full px-6 hover:bg-muted ${isActive ? "bg-primary text-white hover:bg-primary/90" : ""}`}
                  key={row.id}
                  data-state={row.getIsSelected() && "selected"}
                >
                  {row.getVisibleCells().map((cell) => (
                    <div
                      key={cell.id}
                      className={`${cell.column.columnDef.size === 1000 ? "grow flex" : "flex flex-none w-[" + cell.column.columnDef.size + "px]"} min-h-12 h-12 items-center text-sm`}
                    >
                      <div className={`min-w-[${cell.column.columnDef.size}px]`}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</div>
                    </div>
                  ))}
                </div>
              )}

            </NavLink>
          ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="h-24 text-center">
                {t("no_data")}
              </TableCell>
            </TableRow>
          )
        }
      </ScrollArea>
    </>
  );
}
